import { createSlice  } from "@reduxjs/toolkit";

const slice = createSlice({
  name: "size",
  initialState: {
    widgetWidth: 320,
    windowHeight: 600,
    isDesktopScreen: true // check default value and default width
  },
  reducers: {
    widgetWidthUpdated: (size, action) => {
      size.widgetWidth = action.payload;
      size.isDesktopScreen = action.payload >= 800;
    },
    windowHeightUpdated: (size, action) => {
      size.windowHeight = action.payload;
    },
  }
});

export const { widgetWidthUpdated, windowHeightUpdated } = slice.actions;
export default slice.reducer;